<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FkpOsY/tc-custom/9780718094966.jpg?1726617369847" alt="This image is the cover for the book Sacred Slow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sacred Slow
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Tired of quick fixes and fast faith? <i>The Sacred Slow</i> is an invitation to unhurried honesty before God. If yesterday’s word was <i>simple</i>, tomorrow’s word will be <i>slow</i>.</b></p><p>Our culture is shifting from fast food to healthy food both physically and spiritually. Self-care, soul-care, life coaches, and spiritual retreats all show our dissatisfaction in quick fixes and fast faith. <i>The Sacred Slow</i> is an invitation to unhurried honesty before God.</p><p>Formatted as 52 experiences, <i>The Sacred Slow</i> reminds readers on every page that God never wanted to use them—He always wanted to love them. The overflow of Dr. Alicia Britt Chole’s more than thirty years as a spiritual mentor to leaders and learners as well as her personal, practical, and penetrating tone will guide you to a richer, more life-giving relationship with God.</p><p>Perfect for use as a devotional or in small groups, each chapter features:</p>A short, unexpected readingTwo options for application—a thought focus or a heart exerciseEncouragement to develop growing, sustainable intimacy with God<p>Whether you’re exhausted by emptiness or worn from weariness, you’ll discover healing and restoration in these pages. In this age of distraction, learn to slow down and reorient your life to learn, grow, and experience God as never before.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alicia Britt Chole
      </h2>
      
      <p class="authorDescription body article"><P>An award-winning writer, Dr. Alicia Britt Chole&rsquo;s messages address both head and heart and are often described as grace-filled surgeries. Alicia is a speaker, author, and leadership mentor who enjoys thunderstorms, jalapenos, and honest questions. To explore Alicia&rsquo;s other books or learn more about her ministry, visit www.aliciabrittchole.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07505820